module.exports = __webpack_public_path__ + "media/images/ir/common/bg_index-ttl-e0e58ad5cf767cacb05b6dbcd0846c42.png";